const UPDATE_NAVIGATION_SUBNIVEL = (state, payload) => {
  state.navegacaoSubnivel = payload
}

export { UPDATE_NAVIGATION_SUBNIVEL }
